import React, {FC, ReactNode} from 'react';
import cn from 'classnames';
import {useLocalizer} from '@/common/services/localizer';
import styles from './Popup.css';

interface PopupProps {
	className?: string;
	title?: string;
	onClose(): void;
	children: ReactNode;
}

export const Popup: FC<PopupProps> = props => {
	const {className, title, onClose, children} = props;
	const t = useLocalizer();

	return (
		<div className={cn(styles.root, className)}>
			<h1 className={styles.title}>{title}</h1>
			<button className={styles.closeButton} type='button' aria-label={t('close')} onClick={onClose} />
			{children}
		</div>
	);
};

Popup.displayName = 'Popup';
